var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-4"},[_c('NewSmsMessageAction',{attrs:{"contact-request":_vm.contactRequest},on:{"created":_vm.setLastCreatedAt}}),_c('MessageList',{key:_vm.lastCreatedAt,attrs:{"contact-request":_vm.contactRequest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }